/* eslint-disable */
import React, { Component } from 'react';

import { Divider, Radio, Table } from 'antd';

import { getPolusSkills } from '@/store/v2/v2';
import PropTypes from 'prop-types';

const { Column } = Table;

export class SkillList extends Component {
  static propTypes = {
    onSelectSkills: PropTypes.func,
    competence: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      skills: [],
    };
  }

  componentDidMount() {
    const { currentUser, competence } = this.props;
    this.setState({ isLoading: true });
    getPolusSkills(
      currentUser.id,
      competence.key,
      res => {
        if (res && Array.isArray(res) && res.length) {
          let skills = [];
          res.map(skill => {
            let object = {
              key: skill.id,
              name: skill.name,
            };

            skills.push(object);
          });

          this.setState({
            skills: skills,
          });
        }
      },
      err => {
        console.error('Error:', err.statusText);
      }
    );

    this.setState({ isLoading: false });
  }

  handleChange = (selectedRowKeys, selectedRows) => {
    if (typeof selectedRows === 'object' && typeof this.props.onSelectSkills === 'function') {
      this.props.onSelectSkills(selectedRows);
    }
  };

  render() {
    const { isLoading, skills } = this.state;
    const { t } = this.props;
    return (
      <>
        <Table
          ellipsis={true}
          bordered={false}
          style={{ width: '100%' }}
          loading={isLoading}
          dataSource={skills}
          pagination={{
            pageSize: 6,
            style: { padding: '1rem' },
          }}
          onSelect={this.handleChange}
          rowSelection={{
            type: 'check',
            onChange: this.handleChange,
          }}
        >
          <Column title={t('skills')} dataIndex='name' key='skills' filterSearch={false} />
        </Table>
      </>
    );
  }
}

export default SkillList;
